import { Injectable } from '@angular/core';
import { Observable, mergeMap, of } from 'rxjs';
import { SyncDataRepository } from 'src/app/driver-data/repositories/sync-data.repository';
import { StoredDispatchedServiceSyncData } from '../../../driver/storage/models/stored-dispatched-service-sync-data';
import { DexieIndexKeys } from 'src/app/dexie/dexie-index-keys';

/**
 * Data operation class for deleting sync data by service legacy ID.
 */
@Injectable({
	providedIn: 'root'
})
export class DeleteSyncDataByLegacyIdOperation {

	/**
	 * @constructor
	 * @param syncDataRepository The repository used for managing sync data.
	 */
	constructor(
		private readonly syncDataRepository: SyncDataRepository
	) { }

	/**
	 * Executes the delete operation for sync data by service legacy ID.
	 * Finds the sync data record matching the legacy ID and deletes it by service ID.
	 * @param serviceLegacyId The service legacy identifier for the sync data record to delete.
	 * @returns An observable that completes when the deletion is finished.
	 */
	public Execute$(serviceLegacyId: number): Observable<void> {
		return this.syncDataRepository.GetByIndex$({
			[DexieIndexKeys.LEGACY_ID]: serviceLegacyId
		}).pipe(
			mergeMap((syncDataRecords: StoredDispatchedServiceSyncData[]) => {
				const recordToDelete: StoredDispatchedServiceSyncData = syncDataRecords[0];
				if (!recordToDelete) {
					return of(void 0);
				}

				return this.syncDataRepository.DeleteById$(recordToDelete.ServiceId);
			})
		);
	}
}
